import React, { useEffect } from 'react';
import { StepProps } from '../../types/onboarding';
import { MessageSquareIcon, RefreshCwIcon, SearchIcon, UsersIcon, DatabaseIcon, CalendarIcon, FileTextIcon, SmartphoneIcon } from 'lucide-react';
const PACKAGES = [{
  id: 'JungoSMS_App',
  name: 'Jungo SMS App',
  icon: MessageSquareIcon,
  color: 'green',
  used: 12,
  total: 50
}, {
  id: 'Jungo_LOS_S',
  name: 'Jungo LOS Sync',
  icon: RefreshCwIcon,
  color: 'green',
  used: 45,
  total: 50
}, {
  id: 'JungoPSApp',
  name: 'Jungo Power Search',
  icon: SearchIcon,
  color: 'green',
  used: 8,
  total: 20
}, {
  id: 'JungoLeadsFrc',
  name: 'Jungo Leads Force',
  icon: UsersIcon,
  color: 'green',
  used: 30,
  total: 100
}, {
  id: 'Jungo_LOS',
  name: 'Jungo LOS Base',
  icon: DatabaseIcon,
  color: 'green',
  used: 48,
  total: 50
}, {
  id: 'MtgPlanner_CRM',
  name: 'Mortgage Planner CRM',
  icon: CalendarIcon,
  color: 'green',
  used: 15,
  total: 25
}, {
  id: 'TVA_CFB',
  name: 'Docuvault',
  icon: FileTextIcon,
  color: 'blue',
  used: 5,
  total: 10
}, {
  id: 'JungoSMS',
  name: 'Jungo SMS Base',
  icon: SmartphoneIcon,
  color: 'green',
  used: 22,
  total: 50
}];
export function PackageLicenses({
  data,
  updateData,
  setCanAdvance
}: StepProps) {
  useEffect(() => {
    setCanAdvance(true);
  }, [setCanAdvance]);
  const togglePackage = (id: string) => {
    const current = data.packageLicenses;
    const newValues = current.includes(id) ? current.filter(v => v !== id) : [...current, id];
    updateData({
      packageLicenses: newValues
    });
  };
  return <div className="space-y-6" data-id="element-203">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-204">
        {PACKAGES.map(pkg => {
        const isSelected = data.packageLicenses.includes(pkg.id);
        const Icon = pkg.icon;
        const isGreen = pkg.color === 'green';
        return <div key={pkg.id} className={`flex items-center justify-between p-4 bg-white rounded-xl border transition-all ${isSelected ? 'border-[#2563EB] shadow-md ring-1 ring-[#2563EB]/20' : 'border-gray-200 shadow-sm hover:border-gray-300'}`} data-id="element-205">
              <div className="flex items-center space-x-4" data-id="element-206">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isGreen ? 'bg-[#2E844A]/10' : 'bg-[#2563EB]/10'}`} data-id="element-207">
                  <Icon className={`w-5 h-5 ${isGreen ? 'text-[#2E844A]' : 'text-[#2563EB]'}`} data-id="element-208" />
                </div>
                <div data-id="element-209">
                  <h4 className="text-sm font-semibold text-gray-900" data-id="element-210">
                    {pkg.name}
                  </h4>
                  <div className="flex items-center mt-1 space-x-2" data-id="element-211">
                    <div className="w-16 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-212">
                      <div className={`h-full rounded-full ${isGreen ? 'bg-[#2E844A]' : 'bg-[#2563EB]'}`} style={{
                    width: `${pkg.used / pkg.total * 100}%`
                  }} data-id="element-213" />
                    </div>
                    <span className="text-[10px] font-medium text-gray-500" data-id="element-214">
                      <span className="text-gray-900" data-id="element-215">{pkg.used}</span>/
                      {pkg.total}
                    </span>
                  </div>
                </div>
              </div>

              <button type="button" onClick={() => togglePackage(pkg.id)} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${isSelected ? 'bg-[#2563EB]' : 'bg-gray-200'}`} data-id="element-216">
                <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${isSelected ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-217" />
              </button>
            </div>;
      })}
      </div>
    </div>;
}